import React from 'react';
import ReactDOM from 'react-dom';
import Modal from './Modal';

let modal_instance_counter = 0;

class ModalInstance {
    modal_reference = null;

    is_closable = true;

    on_before_close_hook = null;

    constructor(element, container, options) {
        modal_instance_counter += 1;
        Mobi2Go.app.mixinEvents(
            `UIExternalModals#${modal_instance_counter}`,
            this
        );

        this.element = element;
        this.container = container;
        this.options = options || {};
    }

    open() {
        if (this.modal_reference) {
            this.modal_reference.open(() => {
                this.scrollToTop();
            });
            this.trigger('open');
        }
    }

    close(retain_overlay = false, force = false) {
        if (this.modal_reference && this.isOpen()) {
            const hook_allowed_closing =
                this.on_before_close_hook === null ||
                this.on_before_close_hook();
            if ((this.is_closable && hook_allowed_closing) || force) {
                this.modal_reference.close();
                this.trigger('close', retain_overlay);
            }
        }
    }

    isOpen() {
        return !!(this.modal_reference && this.modal_reference.isOpen());
    }

    scrollToBottom() {
        if (this.modal_reference) {
            this.modal_reference.scrollToBottom();
        }
    }

    scrollToTop() {
        if (this.modal_reference) {
            this.modal_reference.scrollToTop();
        }
    }

    scrollElementIntoView(...args) {
        if (this.modal_reference) {
            this.modal_reference.scrollElementIntoView(...args);
        }
    }

    setIsClosable(is_closable) {
        this.is_closable = is_closable;
        if (this.is_closable) {
            this.container.classList.remove('m2g-modal--modal-frozen');
        } else {
            this.container.classList.add('m2g-modal--modal-frozen');
        }
        this.trigger('isClosableChange', this.is_closable);
    }

    isClosable() {
        return this.isClosable;
    }

    setOnBeforeCloseHook(on_before_close_hook) {
        this.on_before_close_hook = on_before_close_hook;
    }

    mount() {
        ReactDOM.render(
            <Modal
                ref={new_modal_reference => {
                    this.modal_reference = new_modal_reference;
                }}
                onClickOutsideModal={() => this.close()}
                modalProps={this.options}
            >
                {this.element}
            </Modal>,
            this.container
        );
    }
}

export default ModalInstance;
